exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".scroller-stage{overflow:auto;position:relative}.scroller-stage .scroller-box{position:absolute;top:0;left:0;width:100%}.scroller-stage .scroller-bar{position:absolute;top:0;right:0;width:5px;opacity:.6;background-color:#000}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/components/base/scroller/scroller.scss
// module id = 576
// module chunks = 2